@if (selectedCount() > 0) {
  <div class="table-selection-bar" data-cy="table-selection-bar">
    <div class="table-selection-bar__head">
      <div class="table-selection-bar__selection">
        <span class="table-selection-bar__summary">
          <span class="table-selection-bar__count">{{ selectedCount() }}</span>
          <span class="table-selection-bar__label"
            >of {{ totalCount() }} selected</span
          >
        </span>
        <span class="table-selection-bar__controls">
          <button
            pButton
            type="button"
            size="small"
            severity="primary"
            variant="text"
            class="table-selection-bar__select-all"
            (click)="selectAll.emit()"
          >
            <i class="pi pi-check-square"></i>
            Select All
          </button>
          <button
            pButton
            type="button"
            size="small"
            severity="primary"
            variant="text"
            class="table-selection-bar__clear"
            (click)="clearSelection.emit()"
          >
            <i class="pi pi-ban"></i>
            <!-- One flex item: the button's gap would split "Clear selection". -->
            <span
              >Clear<span class="table-selection-bar__clear-suffix">
                selection</span
              ></span
            >
          </button>
        </span>
      </div>
      <button
        pButton
        type="button"
        size="small"
        severity="secondary"
        variant="text"
        class="table-selection-bar__close"
        aria-label="Clear selection"
        (click)="clearSelection.emit()"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>
    <div class="table-selection-bar__actions">
      <ng-content />
    </div>
  </div>
}
